import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '~env';
import { ApiError } from '~shared/models/api-error.model';
import { AuthenticationService } from '~shared/services/authentication.service';
import { PuToastrService } from '~shared/services/toastr/pu-toastr.service';

const LOGOUT_ERROR_CODES: string[] = [
  'INVALID_TOKEN',
  'TOKEN_NOT_FOUND',
  'TOKEN_EXPIRED',
];

@Injectable({
  providedIn: 'root',
})
export class AuthenticationInterceptor implements HttpInterceptor {
  private authenticationService = inject(AuthenticationService);
  // Résolu paresseusement : injecter PuToastrService au démarrage tirerait
  // TranslateService puis HttpClient, et refermerait un cycle de dépendances
  // sur l'intercepteur lui-même.
  private injector = inject(Injector);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const authenticationIsNeeded = Object.values(environment.apiBasePaths).some(
      (apiBasePath) => req.url.startsWith(apiBasePath)
    );

    const token = this.authenticationService.getJwtToken();

    let authReq: HttpRequest<unknown> = req;
    if (authenticationIsNeeded && token) {
      authReq = authReq.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + token),
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        const apiError: ApiError = error.error;

        if (LOGOUT_ERROR_CODES.includes(apiError?.error)) {
          // Expiration/invalidation de session : on ANNONCE avant la
          // redirection silencieuse vers /login (RGAA 13.1). La garde sur le
          // jeton dédoublonne : plusieurs requêtes concurrentes qui échouent
          // n'annoncent qu'une fois, car la première déconnexion purge le jeton.
          if (this.authenticationService.getJwtToken()) {
            this.injector
              .get(PuToastrService)
              .warningKey('LOGIN.SESSION_EXPIRED');
          }
          this.authenticationService.logout();
        }

        return throwError(() => error);
      })
    );
  }
}
